module.exports = __webpack_public_path__ + "img/dropdown_white.deb95af8.svg";